module.exports = __webpack_public_path__ + "static/media/Jimmy.dd23edd3.jpg";